// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { externalLink } from './assets/modules/externalLink';
import { modal } from './assets/modules/modal';
import { fluidvideo } from './assets/modules/fluidvideo';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe';
import { trigger } from './assets/modules/trigger';
import { stickySidebar } from './assets/modules/stickySidebar';
import { chat } from './assets/modules/chat';
import { list } from './assets/modules/list';
import { accordion } from './assets/modules/accordion';

const init = () => {
  hover();
  externalLink();
  modal();
  accordion();
  fluidvideo();
  initPhotoSwipeFromDOM('.js-pswp-container');
  trigger();
  stickySidebar();
  chat();
  list();
}

init();